import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, isAdmin, isRestricted, hasWeeklyWins } from "../contexts/AuthContext";

// Paths a restricted (family / trainer) user IS allowed to visit.
const RESTRICTED_ALLOWED = ["/my-players", "/player/", "/home/", "/login"];

export default function ProtectedRoute({ children, adminOnly = false, familyAllowed = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[var(--org-accent)]" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }
  // Family + trainer users only see /my-players and /player/:id (+ Weekly Wins when the add-on is on)
  if (isRestricted(user) && !familyAllowed) {
    const path = location.pathname;
    const allowed = RESTRICTED_ALLOWED.some(p => path.startsWith(p)) || (hasWeeklyWins(user) && path.startsWith("/weekly-wins"));
    if (!allowed) return <Navigate to="/my-players" replace />;
  }
  if (adminOnly && !isAdmin(user)) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 text-center">
        <div>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[var(--org-accent)] mb-3">403 · Admin Only</div>
          <div className="font-heading text-3xl text-white uppercase">This area is restricted</div>
          <div className="mt-3 text-sm text-[#a0a0a0]">Ask your admin for access.</div>
        </div>
      </div>
    );
  }
  return children;
}
